import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const resolveOriginal = Router.prototype.push
Router.prototype.push = function push(location) {
    return resolveOriginal.call(this, location).catch(err => err)
}

let router = new Router({
    routes: [{
        path: "/login",
        component: () =>
            import("../pages/account/login.vue"),
    },
    {
        path: "/register",
        component: () =>
            import("../pages/account/register.vue")
    },

    {
        path: "/forgetPassword",
        component: () =>
            import("../pages/account/forgetPassword.vue")
    },
    {
        path: "/notice",
        name: "通知",
        component: () =>
            import("../pages/notice.vue"),
        meta: {
            requireAuth: true
        }
    },
    {
        path: "/",
        meta: {
            requireAuth: true
        },
        component: () =>
            import("../pages/index/index.vue"),
        children: [{
            path: "/",
            name: "首页2",
            component: () =>
                import("../pages/project/index.vue"),
            meta: {
                requireAuth: true
            }
        }, {
            path: "home",
            name: "首页",
            component: () =>
                import("../pages/user/home.vue"),
            meta: {
                requireAuth: true
            }
        },
        {
            path: "accountSecurity",
            name: "账户安全",
            component: () =>
                import("../pages/user/accountSecurity.vue"),
            meta: {
                requireAuth: true
            }
        },
        {
            path: "mall",
            name: "在线商城 ",
            component: () =>
                import("../pages/mall/onlinemall.vue"),
            meta: {
                requireAuth: true
            }
        },
        {
            path: "business",
            name: "业务办理",
            component: () =>
                import("../pages/business/index.vue"),
            meta: {
                requireAuth: true
            },
        },
        {
            path: "scoreDetail",
            name: "成绩详情",
            meta: {
                requireAuth: true
            },
            component: () =>
                import("../pages/business/scoreDetail.vue"),

        },
        {
            path: "project",
            name: "考试报名",
            component: () =>
                import("../pages/project/index.vue"),
            meta: {
                requireAuth: true
            }
        },
        {
            path: "apply",
            name: "考试文件",
            component: () =>
                import("../pages/project/apply.vue"),
            meta: {
                requireAuth: true
            }
        },

        ]
    },
    {
        path: '*',
        name: 'NotFound',
        component: () => import("../pages/NotFound.vue")
    },
    ]
})


//登录拦截
// router.beforeEach((to, from, next) => {

// 	if (to.path == "/login") {
// 		next()
// 		return
// 	}

// 	if (store.state.userInfo.id) {
// 		next()
// 		return
// 	}

// 	next("/login")
// })

export default router

router.beforeEach((to, from, next) => {
    //获取用户信息
    let userCertInfo = JSON.parse(localStorage.getItem("userCertInfo"));

    if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
        if (localStorage.getItem("token") != null) { // 判断本地是否存在token
            //判断是否已实名认证 start

            if (userCertInfo == null && to.path != "/home") {
                next('/home');
            }
            //判断是否已实名认证 end
            next()
        } else {
            // 未登录,跳转到登陆页面
            next({
                path: '/login'
            })
        }
    } else {

        if (localStorage.getItem("token") != null) {
            //判断是否已实名认证 start
            if (userCertInfo == null && to.path != "/home") {
                next('/home');
            }
            //判断是否已实名认证 end
            //已登录
            next('/home');
        } else {
            next();
        }
    }
});